var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center sso-logout"},[_c('div',{staticClass:"sso-logout__info"},[_c('p',[_vm._v(" Thank you for using Hotspex Labs. "),_c('br'),_c('span',{on:{"click":_vm.loginUrl}},[_vm._v("Login")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }